import { isOfferingsPostRequest } from './injectFlowTypeIntoOfferingsRequest';
import type { InterpolatedRequest } from './fetchDataSource';

/**
 * Auto-inject the visitor's `trafficSource` into Offerings POST bodies,
 * mirroring {@link injectFlowTypeIntoOfferingsRequest}. Step-configured values
 * win over URL-derived `utm_cap` tokens. Budget selection differs by traffic
 * source, so this is a distinct dimension from `flowType`.
 */
export function injectTrafficSourceIntoOfferingsRequest(
  req: InterpolatedRequest,
  trafficSource: string | undefined,
): InterpolatedRequest {
  if (!trafficSource || !isOfferingsPostRequest(req)) {
    return req;
  }

  const body = req.body;
  if (body === undefined || body === null) {
    return { ...req, body: { trafficSource } };
  }
  if (typeof body !== 'object' || Array.isArray(body)) {
    return req;
  }

  return {
    ...req,
    body: { ...(body as Record<string, unknown>), trafficSource },
  };
}
